import styled from "@emotion/styled";

export const ButtonsWrapper = styled.div`
  text-align: center;
  margin-top: 30px;
`;

export const Field = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:first-of-type {
    margin-bottom: 0.9375rem;
    // border-bottom: 1px dashed #e0e0e0;
    // padding-bottom: 17.5px;
  }

  input {
    margin-top: 0.3125rem;
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  display: block;
`;

export const Form = styled.form``;
